import { TextField, type TextFieldProps } from "$components/inputs";
import { styled } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import React from "react";

const SearchIcon = styled(Search)(() => ({
  fontSize: 24,
  pointerEvents: "none", // ensure users can click through icon
}));

export type SearchFieldProps = {
  onClear?: () => void;
} & TextFieldProps;

export const SearchField = React.memo(
  React.forwardRef(
    (
      { name, value, onClear: handleClear, ...props }: SearchFieldProps,
      ref: React.Ref<HTMLInputElement>,
    ) => {
      return (
        <TextField
          type="search"
          name={name}
          InputProps={{
            endAdornment: <SearchIcon color="secondary" />,
          }}
          {...props}
          onClear={handleClear}
          value={value}
          ref={ref}
        />
      );
    },
  ),
);
